<template>
  <v-alert :value="visible">
    <v-layout
      v-if="closed"
      justify-end
    >
      <v-icon
        class="clickable"
        @click="hideAlert"
      >
        clear
      </v-icon>
    </v-layout>
    <h4 class="display-1 display-1_dark mb-3">
      {{ alertText() }}
    </h4>
    <v-layout
      v-if="getLastRefusal.reason"
      class="mb-2"
      :wrap="smAndDownScreen"
    >
      <v-flex
        lg2
        md2
        sm12
      >
        <span class="fw-600 f-1">{{ $t('family_card.turn_off.reason') | addColons }}</span>
      </v-flex>
      <v-flex
        lg10
        md10
        sm12
      >
        <p class="mb-0 f-1">
          {{ getLastRefusal.reason.name }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="getLastRefusal.description"
      class="mb-2"
      :wrap="smAndDownScreen"
    >
      <v-flex
        lg2
        md2
        sm12
      >
        <span class="fw-600 f-1">{{ $t('family_card.turn_off.description') | addColons }}</span>
      </v-flex>
      <v-flex
        lg10
        md10
        sm12
      >
        <p class="mb-0 f-1">
          {{ getLastRefusal.description }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="exclusionReasons"
      class="mb-2"
      :wrap="smAndDownScreen"
    >
      <v-flex
        lg2
        md2
        sm12
      >
        <span class="fw-600 f-1">{{ $t('family_card.turn_off.reason') | addColons }}</span>
      </v-flex>
      <v-flex
        lg10
        md10
        sm12
      >
        <p class="mb-0 f-1">
          <span
            v-for="(reason, index) in exclusionReasons"
            :key="index"
          >{{ reason.name }}<span v-if="index + 1 !== exclusionReasons.length">, </span></span>
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="getLastReason.description"
      class="mb-2"
      :wrap="smAndDownScreen"
    >
      <v-flex
        lg2
        md2
        sm12
      >
        <span class="fw-600 f-1">{{ $t('family_card.turn_off.description') | addColons }}</span>
      </v-flex>
      <v-flex
        lg10
        md10
        sm12
      >
        <p class="mb-0 f-1">
          {{ getLastReason.description }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      v-if="getLastReason.explanation"
      class="mb-2"
      :wrap="smAndDownScreen"
    >
      <v-flex
        lg2
        md2
        sm12
      >
        <span class="fw-600 f-1">{{ $t('family_card.turn_off.explanation') | addColons }}</span>
      </v-flex>
      <v-flex
        lg10
        md10
        sm12
      >
        <p class="mb-0 f-1">
          {{ getLastReason.explanation }}
        </p>
      </v-flex>
    </v-layout>
    <v-layout v-if="isCurrentEdition && hasPermissionVolunteerAssign">
      <v-spacer />
      <v-flex
        v-if="manageVolunteers"
        lg10
        @click="assignVolunteer()"
      >
        <a>{{ $t('buttons.choose_main_volunteer') }}</a>
      </v-flex>
    </v-layout>
  </v-alert>
</template>

<script>
import filters from '@/constants/filters';
export default {
    name: 'TurnOffAlert',
    filters: {
        ...filters
    },
    props: {
        fullName: {
            type: String
        },
        refusal: {
            type: Array,
            default: null
        },
        reason: {
            type: Array,
            default: null
        },
        title: {
            type: String
        },
        manageVolunteers: {
            type: Boolean,
            default: false
        },
        closed: {
            type: Boolean,
            default: false
        },
        hasPermissionVolunteerAssign: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            visible: true
        };
    },
    computed: {
        smAndDownScreen () {
            return this.$vuetify.breakpoint.smAndDown;
        },
        getLastRefusal () {
            let ref = {};
            if (this.refusal !== null && this.refusal !== undefined) {
                ref = this.refusal[this.refusal.length - 1];
            }
            return ref;
        },
        getLastReason () {
            let ref = {};
            if (this.reason !== null && this.reason !== undefined) {
                ref = this.reason[this.reason.length - 1];
            }
            return ref;
        },
        exclusionReasons () {
            return this.getLastReason.exclusion_reasons || null;
        },
        hydraUserName () {
            const { user_first_name: firstName, user_last_name: lastName } = this.getLastReason || null;
            return firstName && lastName ? `${firstName} ${lastName}` : null;
        },
        volunteerName () {
            if (this.getLastRefusal.volunteer) {
                return this.getLastRefusal.volunteer.full_name;
            }
            if (this.refusal && this.refusal.length > 0) {
                return this.refusal[0].volunteer_full_name;
            }
            if (this.hydraUserName) {
                return this.hydraUserName;
            }
            return '';
        },
        createdAt () {
            return (
                (this.getLastRefusal && this.getLastRefusal.created_at) ||
        (this.getLastReason && this.getLastReason.created_at)
            );
        },
        createdAtDate () {
            const date = new Date(this.createdAt);
            return date.toLocaleDateString();
        },
        createdAtTime () {
            const date = new Date(this.createdAt);
            return date.toLocaleTimeString();
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    },
    watch: {
        title () {
            this.visible = true;
        }
    },
    methods: {
        assignVolunteer () {
            this.$emit('assignVolunteer');
        },
        hideAlert () {
            this.visible = false;
        },
        alertText () {
            return (
                this.$t('label.family') +
        ' ' +
        this.fullName +
        ' ' +
        this.title +
        ' ' +
        this.volunteerName +
        ' ' +
        this.$t('family_card.changelog.change_date', {
            date: this.createdAtDate,
            time: this.createdAtTime
        })
            );
        }
    }
};
</script>

<style scoped></style>
